import script from "./LegalMarkdownLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalMarkdownLoader.vue?vue&type=script&setup=true&lang=js"

import "./LegalMarkdownLoader.vue?vue&type=style&index=0&id=7359f98e&lang=css"

const __exports__ = script;

export default __exports__